import { useNavigate } from '@exam-management/router';
import {
  Button,
  NoRowsOverlay,
  SyncOutlinedIcon,
  Flex,
  ArrowBackOutlinedIcon,
} from '@shared/components';

interface GeneratingOverlayProps {
  courseId: string;
}

export default function GeneratingOverlay(props: Readonly<GeneratingOverlayProps>) {
  const { courseId } = props;
  const navigate = useNavigate();
  return (
    <Flex
      sx={{
        py: (theme) => theme.spacing(20),
      }}
    >
      <NoRowsOverlay
        icon={SyncOutlinedIcon}
        title='กำลังสร้าง QConfig'
        description='โปรดรอสักครู่ ขณะนี้ระบบกำลังสร้าง QConfig ตามเงื่อนไขที่คุณกำหนด'
        action={
          <Button
            variant='outlined'
            startIcon={<ArrowBackOutlinedIcon />}
            color='secondary'
            onClick={() => {
              navigate('/exam-courses/:courseId/qconfig-generators', {
                params: { courseId },
              });
            }}
          >
            Back
          </Button>
        }
        slotProps={{
          wrapper: {
            disablePadding: true,
          },
          icon: {
            fontSize: 100,
            color: 'primary',
          },
        }}
      />
    </Flex>
  );
}
